import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05ba7006"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "customer-changer",
  class: "nav flex-column"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas ms-3" }, "arrow_right", -1))
const _hoisted_5 = {
  class: "collapse",
  id: "customer-collapse"
}
const _hoisted_6 = { class: "ms-0 list-unstyled pb-1 text-white" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1" }, "exit_to_app", -1))
const _hoisted_10 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_11 = { class: "search-customers position-relative w-100 me-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-submit" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-green mb-3",
    id: "btnSearchSubmit",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "search")
  ])
], -1))
const _hoisted_13 = {
  key: 0,
  id: "pharmacy-changer",
  class: "nav flex-column mt-2"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas ms-3" }, "arrow_right", -1))
const _hoisted_17 = {
  class: "collapse",
  id: "pharmacy-collapse"
}
const _hoisted_18 = { class: "ms-0 list-unstyled pb-1 text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "d-block collapsed btn btn-toggle bg-primary-dark align-items-center rounded text-start text-white fs-5",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.toggleCustomerCollapse && this.toggleCustomerCollapse(...args)))
        }, [
          (this.currentCustomer?.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(this.currentCustomer.name), 1))
            : _createCommentVNode("", true),
          (!this.currentCustomer?.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t('selectPharmacy')), 1),
                _hoisted_4
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.customerOverview, (customer) => {
              return (_openBlock(), _createElementBlock("li", {
                key: customer.customer_code,
                style: {"z-index":"105"}
              }, [
                _createVNode(_component_router_link, {
                  class: "d-block bg-white text-primary text-decoration-none py-1 px-2",
                  to: "/",
                  onClick: ($event: any) => (this.switchCustomer(customer.customer_code))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128)),
            (this.hasMoreCustomersToShow)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    class: "d-flex flex-row justify-content-between align-items-center bg-white text-primary text-decoration-none py-1 px-2",
                    to: {name: 'pharmacies'}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('allPharmacies')), 1),
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (this.isDpUser)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createVNode(_component_dp_form, {
                    onSubmit: this.searchCustomers,
                    as: "form",
                    novalidate: "",
                    class: "d-flex justify-content-between align-items-center"
                  }, {
                    default: _withCtx(({ errors }) => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_input_text, {
                          modelValue: this.customerCriteria.search_name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.customerCriteria.search_name) = $event)),
                          label: `${_ctx.$t('searchCustomer')}...`,
                          name: "search-customer",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors"]),
                        (this.customerCriteria.search_name)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn-search-reset btn-close position-absolute h-100",
                              type: "reset",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (this.resetSearchCustomers && this.resetSearchCustomers(...args)))
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (this.isMultiPharmacy)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "d-block collapsed btn btn-toggle bg-primary-dark align-items-center rounded text-start text-white fs-5",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (this.togglePharmacyCollapse && this.togglePharmacyCollapse(...args)))
            }, [
              (this.currentPharmacyName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(this.currentPharmacyName), 1))
                : _createCommentVNode("", true),
              (!this.currentPharmacyName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.$t('selectPharmacy')), 1),
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.pharmacyOverview, (pharmacy) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: pharmacy.code,
                    style: {"z-index":"105"}
                  }, [
                    _createVNode(_component_router_link, {
                      class: "py-1 px-2 text-decoration-none d-block bg-white text-primary",
                      to: "/",
                      onClick: ($event: any) => (this.switchPharmacy(pharmacy.code))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(pharmacy.description), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}